<ion-app>
    <ng-container *ngIf="emManutencao; else mainContent">
      <usucampeao-em-manutencao></usucampeao-em-manutencao>
    </ng-container>
    <ng-template #mainContent>
      <usucampeao-menu></usucampeao-menu>
      <ion-router-outlet id="main-content"></ion-router-outlet>
    </ng-template>
  </ion-app>